
      export default {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"data-name":"Lager 1","xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 88.54 88.54"}, attrs),
              ...rest,
            },
            children.concat([_c('defs',[_c('clipPath',{attrs:{"id":"a"}},[_c('path',{attrs:{"fill":"none","d":"M0 0h88.54v88.54H0z"}})])]),_c('g',{attrs:{"clip-path":"url(#a)"}},[_c('path',{attrs:{"d":"M.31 49.4a44.25 44.25 0 0073.31 28l2.12-2A44.27 44.27 0 100 44.27c0 1.06.05 2.1.12 3.13z","fill":"#ee7203"}})]),_c('path',{attrs:{"d":"M37.31 44.75l-.91 3.71s4.75 3.17 7.75 3.9 8.13 0 8.13 0l.91-3.7a4.69 4.69 0 00-2.39-5.43L74.24 11.6c-2-2.2-3.81-3.11-5.94-4.6L42.83 41.14c-2.67 0-5 1.39-5.52 3.61","fill":"#fff"}}),_c('path',{attrs:{"d":"M40.86 67.74c-15-3.69-19.7-8.45-20.89-10L23.33 49c3.34 3.45 11.31 6.77 19.54 8.79S59.7 60.55 64.27 59l-1.1 9.42c-1.5.82-7.26 3-22.31-.72M68.27 58v-.09l.18-1.61c.74-4.08-5.55-8.15-13.45-11.1a7.44 7.44 0 01.19 4.12v.08c6.56 2.64 9.57 5.32 9.56 6.21v.24l-.13 1.06c-2.78 1.36-10.55 1.6-21.18-1S25.94 49.47 24.1 47l.25-.65.13-.35.07-.21c.38-.77 4-1.71 10.48-1.18v-.2A6.53 6.53 0 0137.31 41c-8.13-.94-15.22-.2-16.43 3.64l-5.13 13.3.28.7c.32.79 5.12 7.88 25.35 12.85s24.44 0 25-.63l.44-.47z","fill":"#fff"}})])
          )
        }
      }
    